const productControls = document.querySelectorAll(".product-control");
const products = document.querySelectorAll(".sr-click-to-reveal__product");
const hideProductMobileControllers = document.querySelectorAll(".close-action");
const productDots = document.querySelectorAll(".product-dot");

const clickToRevealSection = document.querySelector(".sr-click-to-reveal");

function closeAllRevealedProducts() {
  products.forEach((product) => {
    product.setAttribute("data-highlighted", "false");
  });
}

function dataHighlightedAttribute(element, state) {
  element.setAttribute("data-highlighted", `${state}`);
}

hideProductMobileControllers.forEach((closeController) => {
  closeController.addEventListener("click", closeAllRevealedProducts);
});

productControls.forEach((productControl) => {
  productControl.addEventListener("click", (e) => {
    switchSlides(e);
  });
});

productDots.forEach((productDot) => {
  productDot.addEventListener("click", (e) => {
    switchSlides(e);
  });
});

function switchSlides(e) {
  const productIndexToAppear = e.target.getAttribute("data-controls");
  const productShown = document.getElementById(
    `revealed-product--${productIndexToAppear}`
  );
  const activeProductDots = document.querySelectorAll(
    `.product-dot--${productIndexToAppear}`
  );

  closeAllRevealedProducts();
  productDots.forEach((productDot) => {
    dataHighlightedAttribute(productDot, false);
  });

  activeProductDots.forEach((activeProductDot) => {
    dataHighlightedAttribute(activeProductDot, true);
  });
  const productShownHasDataHighlighted =
    productShown.getAttribute("data-highlighted") === "true";

  if (!productShownHasDataHighlighted) {
    closeAllRevealedProducts();
    dataHighlightedAttribute(productShown, true);
  }
}

function hideProductInfoMobile() {
  if (window.innerWidth < 769) {
    closeAllRevealedProducts();
  }
  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio >= 0.8) {
        // Perform the action you want when 80% of the element is in view
        products[1].setAttribute("data-highlighted", "true");
        // Optionally, unobserve the element if you only want to trigger the action once
        observer.unobserve(entry.target);
      }
    });
  };

  // Create a new intersection observer with the callback and options
  const observer = new IntersectionObserver(handleIntersection, {
    root: null, // Use the viewport as the root
    rootMargin: "0px",
    threshold: 0.8, // 80% threshold
  });

  // Start observing the element
  observer.observe(clickToRevealSection);
}

hideProductInfoMobile();
